/* eslint-disable no-unused-vars */
import axios from 'axios'
import moment from 'moment'

const state = {
  creneaux: [],
  joursDeRepos: [],
}

const mutations = {
  ADD_CRENEAU(state, _creneau) {
    state.creneaux = state.creneaux.filter((c) => c.creneauTriId !== _creneau.creneauTriId)
    state.creneaux.push(_creneau)
  },
  ADD_CRENEAUX(state, _creneaux) {
    _creneaux.forEach((_creneau) => {
      state.creneaux = state.creneaux.filter((c) => c.creneauTriId !== _creneau.creneauTriId)
      state.creneaux.push(_creneau)
    })
  },
  REMOVE_CRENEAUX_DE_TRAVAIL(state, _creneaux) {
    _creneaux.forEach((_creneau) => {
      state.creneaux = state.creneaux.filter((c) => !(c.creneauTriId === _creneau.creneauTriId))
    })
  },
  ADD_JOURS_DE_REPOS(state, _joursDeRepos) {
    _joursDeRepos.forEach((_jourDeRepos) => {
      state.joursDeRepos.push(_jourDeRepos)
    })
  },
  FLUSH(state, _serviceId) {
    state.creneaux = state.creneaux.filter((c) => !(c.membre.serviceId === _serviceId))
    state.joursDeRepos = state.joursDeRepos.filter((jr) => !(jr.membre.serviceId === _serviceId))
  },
  FLUSH_DATE_MEMBRE(state, _flush) {
    state.creneaux = state.creneaux.filter((c) => !(c.date === _flush.date && c.membre.membreId === _flush.membreId))
    /*state.joursDeRepos = state.joursDeRepos.filter(
      (jr) =>
        !(jr.semaine.semaine === _flush.semaine && jr.semaine.annee === _flush.annee && jr.membreId === _flush.membreId)
    )*/
  },
}

const getters = {
  getCreneaux: (state) => () => {
    return state.creneaux ? state.creneaux : []
  },
  getJoursDeRepos: (state) => () => {
    return state.joursDeRepos ? state.joursDeRepos : []
  },
  getCreneauDeTravailById: (state) => (_creneauId) => {
    return state.creneaux.find((c) => c.creneauId === _creneauId)
  },
  getRemplacants: (state) => (_creneau) => {
    return state.creneaux.filter((c) => c.remplace && c.remplace.creneauId === _creneau.creneauId)
  },
}

const actions = {
  flush({ state, commit }, _serviceId) {
    commit('FLUSH', _serviceId)
  },
  refreshDateMembre({ commit }, _query) {
    commit('FLUSH_DATE_MEMBRE', _query)
    return axios
      .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/membre/${_query.membreId}?_date=${_query.date}`)
      .then((response) => {
        if (response.data) {
          commit('ADD_CRENEAUX', response.data)
        }
      })
  },
  // Recharge chaque jour touché (pour les créneaux de nuit à cheval sur deux jours)
  refreshPlageMembre({ dispatch }, { membreId, debut, fin }) {
    const jours = []
    let currentDate = moment(debut)
    for (const jour = currentDate.startOf('day'); jour.isBefore(fin); jour.add(1, 'day')) {
      jours.push(jour.format('YYYY-MM-DD'))
    }
    return Promise.all(
      jours.map((jour) => {
        return dispatch('refreshDateMembre', {
          date: jour,
          membreId: membreId,
        })
      })
    )
  },
  fetchCreneauxSemaineByService({ commit, dispatch }, _query) {
    return axios
      .get(
        `${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/service/${_query.serviceId}/semaine?_annee=${_query.annee}&_semaine=${_query.semaine}`
      )
      .then((response) => {
        if (response.data) {
          commit('ADD_CRENEAUX', response.data)
        }
      })
  },
  obtenirTempsDeTravailByServiceVirtuel({ commit, dispatch }, _query) {
    return axios
      .get(
        `${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/etablissement/${_query.etablissementId}/service-virtuel/${_query.serviceId}/semaine?annee=${_query.annee}&semaine=${_query.semaine}`
      )
      .then((response) => {
        if (response.data) {
          commit('ADD_CRENEAUX', response.data)
          return response.data
        }
      })
  },
  fetchJourDeReposSemaineByService({ commit }, _query) {
    return axios
      .get(
        `${process.env.VUE_APP_URL_BACK_SERENITY}/jourDeRepos/service/${_query.serviceId}?_annee=${_query.annee}&_semaine=${_query.semaine}`
      )
      .then((response) => {
        if (response.data) {
          commit('ADD_JOURS_DE_REPOS', response.data)
        }
      })
  },
  fetchCreneauEntierById({ commit }, _creneauId) {
    return axios.get(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/${_creneauId}`).then((response) => response.data)
  },
  remplacerCreneau({ state, commit }, _payload) {
    return axios.post(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/${_payload.remplaceId}/remplacer`, _payload)
  },
  nePasRemplacer({ state, commit }, _creneauId) {
    return axios
      .put(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/${_creneauId}/nePasRemplacer`)
      .then((response) => {
        commit('ADD_CRENEAU', response.data)
      })
  },
  annulerRemplacement({ state, commit }, _creneauId) {
    return axios
      .delete(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/${_creneauId}/annulerRemplacement`)
      .then((response) => {
        commit('REMOVE_CRENEAUX_DE_TRAVAIL', response.data)
      })
  },
  createCreneauDeTravail({ state, commit, dispatch }, _toCreate) {
    return axios.post(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/travail`, _toCreate).then(() => {
      dispatch('refreshDateMembre', {
        date: _toCreate.date,
        membreId: _toCreate.membreId,
      })
    })
  },
  updateCreneauDeTravail({ state, commit, dispatch }, _toUpdate) {
    return axios
      .put(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/${_toUpdate.creneauId}`, {
        creneauId: _toUpdate.creneauId,
        nouveauDebut: _toUpdate.nouveauDebut,
        nouvelleFin: _toUpdate.nouvelleFin,
      })
      .then(() => {
        dispatch('refreshPlageMembre', {
          membreId: _toUpdate.membreId,
          debut: moment.min(moment(_toUpdate.ancienDebut), moment(_toUpdate.nouveauDebut)),
          fin: moment.max(moment(_toUpdate.ancienneFin), moment(_toUpdate.nouvelleFin)),
        })
      })
  },
  restaurerDuTempsDeTravail({ state, dispatch }, _restaurerDuTempsDeTravailCommand) {
    return axios
      .put(
        `${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/restaurerDuTempsDeTravail`,
        _restaurerDuTempsDeTravailCommand
      )
      .then((response) => {
        const jour = _restaurerDuTempsDeTravailCommand.dateDuTempsDeTravailARestaurer
        return dispatch('refreshPlageMembre', {
          membreId: _restaurerDuTempsDeTravailCommand.membreId,
          debut: moment(jour).subtract(1, 'day'),
          fin: moment(jour).add(1, 'day'),
        })
      })
  },
  retirerDuTempsDeTravail({ state, dispatch }, _retirerDuTempsDeTravailCommand) {
    const commandConforme = {
      membreId: _retirerDuTempsDeTravailCommand.membreId,
      dateDebut: moment(_retirerDuTempsDeTravailCommand.dateDebut)
        .add(_retirerDuTempsDeTravailCommand.heureDebut.heure, 'hours')
        .add(_retirerDuTempsDeTravailCommand.heureDebut.minute, 'minutes')
        .format('YYYY-MM-DDTHH:mm:00'),
      dateFin: moment(_retirerDuTempsDeTravailCommand.dateFin)
        .add(_retirerDuTempsDeTravailCommand.heureFin.heure, 'hours')
        .add(_retirerDuTempsDeTravailCommand.heureFin.minute, 'minutes')
        .format('YYYY-MM-DDTHH:mm:00'),
    }

    return axios
      .put(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/retirerDuTempsDeTravail`, commandConforme)
      .then(() => {
        dispatch('refreshDateMembre', {
          date: _retirerDuTempsDeTravailCommand.dateDebut,
          membreId: _retirerDuTempsDeTravailCommand.membreId,
        })
      })
  },
  createCreneauDeFormation({ state, commit, dispatch }, _toCreate) {
    const commandConforme = {
      labelFormation: _toCreate.labelFormation,
      membreId: _toCreate.membreId,
      debut: moment(_toCreate.date)
        .add(_toCreate.heureDebut.heure, 'hours')
        .add(_toCreate.heureDebut.minute, 'minutes')
        .format('YYYY-MM-DDTHH:mm:00'),
      fin: moment(_toCreate.date)
        .add(_toCreate.heureFin.heure, 'hours')
        .add(_toCreate.heureFin.minute, 'minutes')
        .format('YYYY-MM-DDTHH:mm:00'),
    }

    return axios.post(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/formation`, commandConforme).then(() => {
      dispatch('refreshDateMembre', {
        date: _toCreate.date,
        membreId: _toCreate.membreId,
      })
    })
  },
  annulerCreneauDeFormation({ state, dispatch }, _annuler) {
    return axios
      .delete(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/formation/${_annuler.creneauId}`)
      .then((response) => {
        dispatch('refreshDateMembre', {
          date: _annuler.date,
          membreId: _annuler.membre.membreId,
        })
      })
  },
  annulerCreneauDeDelegation({ dispatch, commit }, _annuler) {
    return axios
      .delete(`${process.env.VUE_APP_URL_BACK_SERENITY}/creneau/delegation/${_annuler.creneauId}`)
      .then(() => {
        commit('planning/REMOVE_CRENEAU', _annuler, { root: true })
        const { annee, semaine } = this.getters['calendrier/getISOWeekOfDate'](_annuler.date)
        dispatch(
          'planning/fetchCreneauxSemaineByUtilisateur',
          {
            utilisateurId: _annuler.membre.employe.utilisateur.utilisateurId,
            annee,
            semaine,
          },
          { root: true }
        )
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
